import { Button } from 'react-bootstrap';
import { Dispatch, SetStateAction } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  copy: string;
  timeInSeconds: number;
  isRutinas: string | null;
}

function ModalMaterialesCopy({
  isOpen,
  setIsOpen,
  copy,
  timeInSeconds,
  isRutinas,
}: Props) {

  function secondsToMmSs(d: number) {
    let m = Math.floor(d / 60);
    let s = Math.floor(d % 60);
    const moreThan5Min = 'un máximo de 24hrs';

    let mDisplay = m < 10 ? '0' + m : m;
    let sDisplay = s < 10 ? '0' + s : s;
    if(m >=5) return moreThan5Min;
    return mDisplay + ":" + sDisplay + "min"; 

  }

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>
      <DialogTitle sx={{ backgroundColor: '#FDB600', marginBottom: '1rem' }}>
        Mensaje
      </DialogTitle>
      <DialogContent className="flex flex-col justify-center items-center overflow-x-hidden">
        <iframe src="https://lottie.host/embed/15b8e80d-e7bb-4eff-adf7-c89f06d1ab14/gE1krkoKvo.json"></iframe>
        <p className="font-bold text-center">
          En {secondsToMmSs(timeInSeconds)} tendremos tu plan de{' '}
          {isRutinas === 'rutinas' ? 'entrenamiento' : 'alimentación'}.
        </p>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setIsOpen(false)}
          className="bg-black"
          style={{ border: 'none' }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalMaterialesCopy;
